// config 檔狀態確認優化，相容舊版字串設定
export function isTrue(config) {
  if (config === '0' || config === 'false') return false
  return Boolean(config)
}
